import type { ItemType } from "@shared/graphql.types";

export const isItemAvailable = (item: ItemType): boolean =>
  item?.type !== "product" || item?.variant?.availability.status === "instock";
